import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";

import Logo from "./logo";

// import SignUpModal from "./../user/modals/sign-up";
import LoginModal from "./../user/modals/login";
import LogoutModal from "./../user/modals/logout";

import { HeaderMiniBreakPoint, HeaderVerticalMenu } from "./../../config/layout";

import { getFullName } from "./../../helpers/profile";
import { getPagePath, getStaticText } from "./../../helpers/system";

import Avatar from "./../../assets/imgs/common/avatar.svg";

import User from "./../user/user";

import CommonText from "./../../const/common.json";

export default class HeaderVertical extends Component {
    _mounted = false;

    constructor(props) {
        super(props);

        this.state = {
            mini: false,
            redirect: false,
            showSignUp: false,
            showLogin: false,
            showLogout: false,
        };
    }

    componentDidMount() {
        this._mounted = true;
        this.initializeEvents();
    }

    componentWillUnmount() {
        this._mounted = false;
        this.unInitializeEvents();
    }

    initializeEvents() {
        document.addEventListener("scroll", (e) => this.onScroll(e));

        // document
        //     .querySelectorAll(`[href$="${getPagePath("UserLogin")}"]`)
        //     .forEach((el) => el.addEventListener("click", (e) => this.onOpenLogin(e)));

        // document
        //     .querySelectorAll(`[href$="${getPagePath("UserLogout")}"]`)
        //     .forEach((el) => el.addEventListener("click", (e) => this.onOpenLogout(e)));
    }

    unInitializeEvents() {
        document.removeEventListener("scroll", (e) => this.onScroll(e));
    }

    onScroll(e) {
        if (e) {
            const { target } = e;
            const { scrollingElement } = target;
            const { scrollTop } = scrollingElement;

            let mini = false;
            if (scrollTop >= HeaderMiniBreakPoint) {
                mini = true;
            }

            if (this._mounted) {
                this.setState({ mini });
            }
        }
    }

    onMenuToggle(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();

            const { target } = e;

            const headerNav = target.closest("#main-header");

            headerNav.classList.toggle("show");
        }

        return false;
    }

    onOpenLogin(e) {
        e.preventDefault();

        this.setState({ showLogin: true });

        return false;
    }

    onCloseLogin(e) {
        this.setState({ showLogin: false });
    }

    onOpenLogout(e) {
        e.preventDefault();

        this.setState({ showLogout: true });

        return false;
    }

    closeLogoutModal(e) {
        this.setState({ showLogout: false });
    }

    onLoginSuccess(e) {
        const userExists = User.get() ? true : false;
        const userProfile = User.getProfile();

        if (userExists) {
            const { borrowerAdditionalInfo } = userProfile;
            const { mc_signup: mcSignUp } = borrowerAdditionalInfo;

            if (mcSignUp) {
                this.setState({ redirect: getPagePath("MotorcyclesDashboard") });
            } else {
                this.setState({ redirect: getPagePath("Dashboard") });
            }

            window.location.reload();
        }
    }

    onLogout(e) {
        const { type } = this.props;

        let logoutLink = getPagePath("UserLogout");
        if (type) {
            logoutLink = `${logoutLink}?${type}`;
        }
        this.setState({ redirect: logoutLink });
    }

    renderLogo() {
        const { homepage = false, type } = this.props;

        let link = getPagePath("HomePage");
        if (type) {
            link = getPagePath("MotorcyclesHomePage");
        }

        let renderedLogo = <Logo darkmode={true} link={link} type={type} />;

        renderedLogo = homepage ? (
            <h1 className="header-logo">{renderedLogo}</h1>
        ) : (
            <span className="header-logo">{renderedLogo}</span>
        );

        return renderedLogo;
    }

    renderAvatar() {
        const { type = false } = this.props;

        const userExists = User.get() ? true : false;
        const userProfile = User.getProfile();
        const userProfilePhoto = User.getProfilePhoto();

        let renderAvatar = "";
        if (userExists) {
            const { avatar: userAvatar = false } = userProfilePhoto;
            const { ekycStatus } = userProfile;
            let userDetail = "My Account";

            const status = ekycStatus ? `${ekycStatus.status}_${ekycStatus.result}`.toLowerCase() : "";

            let avatar = userAvatar ? userAvatar : Avatar;

            const fullName = getFullName(userProfile);
            if (fullName) {
                const { "business-name": businessName = false } = userProfile;
                userDetail = [
                    <strong key="representative-name" title={fullName}>
                        {fullName}
                    </strong>,
                ];

                if (businessName) {
                    userDetail.push(
                        <span key="business-name" title={businessName}>
                            {businessName}
                        </span>,
                    );
                }
                userDetail.push(<em key="view-profile">View Profile &gt;</em>);
            }

            renderAvatar = (
                <div className={`user-profile ${type}`}>
                    <div className="user-avatar">
                        <Link to={getPagePath("Profile")} className="profile-image">
                            <img src={avatar} alt="User Avatar" />
                            <div className={`profile-status ${status}`} />
                        </Link>
                    </div>
                    <div className="user-detail">
                        <Link to={getPagePath("Profile")} title="Go to your Profile">
                            {userDetail}
                        </Link>
                    </div>
                </div>
            );
        }

        return renderAvatar;
    }

    renderPublicMenu() {
        const { type = false } = this.props;

        const renderedPublicMenu = HeaderVerticalMenu[type || "_default"].map((menuItem, menuIdx) => {
            const { path, type = false, labelName } = menuItem;

            let menuLink = "";
            if (type === "external") {
                menuLink = (
                    <a href={path} title={labelName} target={labelName}>
                        <span>{labelName}</span>
                    </a>
                );
            } else {
                menuLink = (
                    <Link to={getPagePath(path)} title={labelName}>
                        <span>{labelName}</span>
                    </Link>
                );
            }

            return <li key={`public-${menuIdx}`}>{menuLink}</li>;
        });

        return renderedPublicMenu;
    }

    renderUserMenu() {
        const renderedPrivateMenu = [];
        const { type = false } = this.props;
        const userExists = User.get() ? true : false;

        let signUpLink = getPagePath("UserSignUp");
        let logoutLink = getPagePath("UserLogout");
        if (type) {
            signUpLink = `${signUpLink}?${type}`;
            logoutLink = `${logoutLink}?${type}`;
        }

        renderedPrivateMenu.push(
            <li key={`private-1`} className={!userExists ? "hide" : ""}>
                <Link
                    to={logoutLink}
                    title={getStaticText(CommonText, "NavLabelLogout", {}, true)}
                    onClick={(e) => this.onOpenLogout(e)}
                >
                    <span>{getStaticText(CommonText, "NavLabelLogout", {}, true)}</span>
                </Link>
            </li>,
        );
        renderedPrivateMenu.push(
            <li key={`private-2`} className={userExists ? "hide" : ""}>
                <Link to={signUpLink} title={getStaticText(CommonText, "NavLabelSignUp", {}, true)}>
                    <span>{getStaticText(CommonText, "NavLabelSignUp", {}, true)}</span>
                </Link>
            </li>,
        );
        renderedPrivateMenu.push(
            <li key={`private-3`} className={userExists ? "hide" : ""}>
                <Link
                    to={getPagePath("UserLogin")}
                    title={getStaticText(CommonText, "NavLabelLogin", {}, true)}
                    onClick={(e) => this.onOpenLogin(e)}
                >
                    <span>{getStaticText(CommonText, "NavLabelLogin", {}, true)}</span>
                </Link>
            </li>,
        );

        return renderedPrivateMenu;
    }

    renderComponents() {
        const { extensions = false } = this.props;
        const { showLogin, showLogout } = this.state;
        const renderedComponents = [];

        const userExists = User.get() ? true : false;

        if (userExists) {
            renderedComponents.push(
                <LogoutModal
                    key="logout-modal-component"
                    show={showLogout}
                    close={(e) => this.closeLogoutModal(e)}
                    onLogout={(e) => this.onLogout(e)}
                    extensions={extensions}
                />,
            );
        } else {
            renderedComponents.push(
                <LoginModal
                    key="login-modal-component"
                    show={showLogin}
                    onClose={(e) => this.onCloseLogin(e)}
                    onSuccess={(e) => this.onLoginSuccess(e)}
                    extensions={extensions}
                />,
            );
        }

        return renderedComponents;
    }

    redirect() {
        const { redirect } = this.state;

        return redirect ? <Redirect to={redirect} /> : false;
    }

    render() {
        const { type = false } = this.props;
        const { mini } = this.state;
        const headerClassNames = ["header"];

        if (mini) {
            headerClassNames.push("mini");
        }

        const userExists = User.get() ? true : false;
        const userProfile = User.getProfile();

        const { profileCompletion } = userProfile;

        let completeProfile = "";
        if (userExists && profileCompletion !== 1) {
            completeProfile = (
                <Link to={getPagePath("Profile")} title="Complete Your Profile">
                    <div className={`profile-complete-card ${type}`}>
                        <div className="complete-text">
                            <h3>Complete Your Profile</h3>
                            <p>Speed up your loan application by completing your profile now.</p>
                        </div>
                    </div>
                </Link>
            );
        }

        return (
            this.redirect() || (
                <header id="main-header">
                    <div className={headerClassNames.join(" ")}>
                        <a href="#menu-toggle" onClick={(e) => this.onMenuToggle(e)}>
                            <span>Menu Toggle</span>
                        </a>
                        {this.renderLogo()}
                    </div>
                    <div className="header-content">
                        {this.renderAvatar()}
                        <nav className="header-nav">
                            {completeProfile}
                            <ul>{this.renderPublicMenu()}</ul>
                        </nav>
                        <nav className="header-user-nav">
                            <ul>{this.renderUserMenu()}</ul>
                        </nav>
                    </div>
                    {this.renderComponents()}
                </header>
            )
        );
    }
}
